export enum Gender {

    NotSet = 0,
    Male = 1,
    Female = 2

}
